import * as Api from '@ViewModels';

interface ICampaignStat {
	count?: number;
	message?: string;
}

export function useCampaignGroup({ campaigns }: { campaigns: Api.ICampaign[] }) {
	const groupId = campaigns[0]?.groupId;
	const groupData: Api.IGroupCampaignData = {
		failedCount: 0,
		noEmailAddressCount: 0,
		openCount: 0,
		repliedCount: 0,
		sentCount: 0,
		status: Api.EmailSendStatus.Ready,
		totalCount: 0,
	};

	let numCompleted = 0;
	let numCancelled = 0;
	campaigns.forEach(campaign => {
		if (campaign.completedDate) {
			numCompleted += 1;
		}

		if (campaign.status === Api.EmailSendStatus.Cancelled) {
			numCancelled += 1;
		}

		groupData.failedCount += campaign.failedCount ?? 0;
		groupData.noEmailAddressCount += campaign.noEmailAddressCount ?? 0;
		groupData.openCount += campaign.openCount ?? 0;
		groupData.repliedCount += campaign.replyCount ?? 0;
		groupData.sentCount += campaign.sentSuccessfullyCount ?? 0;
		groupData.totalCount += campaign.totalEmails ?? 0;
	});
	if (numCompleted === campaigns.length) {
		groupData.status = Api.EmailSendStatus.Complete;
	} else if (numCancelled === campaigns.length) {
		groupData.status = Api.EmailSendStatus.Cancelled;
	} else if (numCompleted + numCancelled === campaigns.length) {
		groupData.status = Api.EmailSendStatus.Complete;
	} else {
		groupData.status = Api.EmailSendStatus.Ready;
	}

	const stats: ICampaignStat[] =
		groupData.status === Api.EmailSendStatus.Complete
			? [
					{ count: groupData.sentCount, message: 'emailed' },
					{ count: groupData.openCount, message: 'viewed' },
					groupData.repliedCount > 0 ? { count: groupData.repliedCount, message: 'replied' } : null,
					groupData.failedCount > 0 ? { count: groupData.failedCount, message: 'failed' } : null,
					groupData.noEmailAddressCount > 0 ? { count: groupData.noEmailAddressCount, message: 'no email' } : null,
				].filter(x => !!x)
			: [
					{
						count: groupData.totalCount - groupData.sentCount - groupData.failedCount - groupData.noEmailAddressCount,
						message: 'queued',
					},
					{
						count: groupData.sentCount,
						message: 'emailed',
					},
					{
						count: groupData.openCount,
						message: 'viewed',
					},
					{
						count: groupData.failedCount,
						message: 'failed',
					},
					{
						count: groupData.noEmailAddressCount,
						message: 'no email',
					},
				];

	return {
		earliestStartDate: new Date(
			Math.min(
				...(campaigns
					.filter(c => c.status !== Api.EmailSendStatus.Cancelled)

					.map(c => new Date(c.schedule.startDate)) as any[])
			)
		),
		groupData,
		groupId,
		groupStats: stats,
	};
}
